/**
 * Whether the engine parses ES2021 syntax (logical assignment: Chrome 85,
 * Safari 14, Firefox 79), the widget bundle's floor. A syntax probe, not an
 * API one: the build's modern polyfills (`@vitejs/plugin-legacy`
 * `modernPolyfills`) would make a probe such as `Promise.any` pass on old
 * WebViews that still cannot parse the bundle.
 */
export function parsesModernSyntax(): boolean {
  try {
    new Function('a', 'a ??= a?.b; return a');
    return true;
  } catch (error) {
    // Only a SyntaxError answers the question; a CSP without
    // 'unsafe-eval' blocks the probe itself, so the load decides.
    return !(error instanceof SyntaxError);
  }
}

/**
 * Whether this browser can run the GPTHelp widget. Old WebViews otherwise
 * fail to parse the bundle and the element never gets defined (a silent
 * 10 s timeout); the widget also renders in a shadow root.
 */
export function isGpthelpSupportedBrowser(): boolean {
  if (typeof window === 'undefined') return false;

  if (typeof customElements === 'undefined') return false;
  if (typeof customElements.get !== 'function') return false;
  if (typeof customElements.whenDefined !== 'function') return false;

  if (typeof Element === 'undefined') return false;
  if (!('attachShadow' in Element.prototype)) return false;

  if (!parsesModernSyntax()) return false;

  if (typeof URLSearchParams === 'undefined') return false;

  if (typeof Intl === 'undefined') return false;
  if (typeof Intl.DateTimeFormat !== 'function') return false;
  if (
    !Intl.DateTimeFormat.prototype ||
    typeof Intl.DateTimeFormat.prototype.formatToParts !== 'function'
  ) {
    return false;
  }

  return true;
}
